import React from "react";

import { Box, Grid, Typography ,Card, CardContent, Avatar} from "@mui/material";


const data = [
    {
      section: "Raw materials & ingredients",
      questions: [
        {
          question: "2.1 Are all raw materials and ingredients used Halal certified?",
          answer: "Yes",
          note: "Atallah Audit Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam."
        },
        { question: "2.2 Are certificates of all Halal ingredients available and up-to-date?", answer: "No" },
        { question: "2.3 How often are suppliers audited for Halal compliance?", answer: "Quarterly" }
      ]
    },
    {
      section: "Food processing and preparation",
      questions: [
        { question: "3.1 Are separate utensils and equipment used for Halal and non-Halal products?", answer: "Yes", image: "https://biofunctionalhealth.com/wp-content/uploads/2021/03/9-1.jpg" },
        { question: "3.2 Is there a clear segregation between Halal and non-Halal products at all stages?", answer: "Yes", image: "https://biofunctionalhealth.com/wp-content/uploads/2021/03/9-1.jpg" },
        { question: "3.3 Are all employees trained in Halal requirements and procedures?", answer: "No" },
        { question: "3.4 Are cleaning and sanitation procedures in place to avoid contamination?", answer: "Yes", image: "https://biofunctionalhealth.com/wp-content/uploads/2021/03/9-1.jpg" }
      ]
    },
    {
      section: "Storage & transportation",
      questions: [
        { question: "4.1 Are Halal products stored separately from non-Halal products?", answer: "Yes" },
        { question: "4.2 Are storage areas clean and well-maintained?", answer: "No" },
        { question: "4.3 Are transportation methods compliant with Halal requirements?", answer: "Yes" },
        { question: "4.4 Are there records of transportation and storage conditions?", answer: "No" }
      ]
    },
    {
        section: "Document and Records",
        questions: [
          { question: "5.1 Are Halal certificates and records properly maintained and accessible?", answer: "Yes" },
          { question: "5.2 Are there document standard operating procedures for Hala compliance?", answer: "No" },
          { question: "5.3 Are are regular internal audit conducted to ensure Halal compliance?", answer: "Yes" },
          { question: "4.4 Are employee aware of the importance of Halal compliance?", answer: "No" }
        ]
      },
      {
        section: "Employee traning & awareness",
        questions: [
          { question: "7.1 Are employees aware of the importance of halal compliance?", answer: "Yes" },
          { question: "7.2 re there document standard operating procedures for Hala compliance?", answer: "No" },
          { question: "7.3 Are are regular internal audit conducted to ensure Halal compliance?", answer: "Yes" },
          { question: "7.4 Are employee aware of the importance of Halal compliance?", answer: "No" }
        ]
      },
      {
        section: "Halal Assurance System (HAS)",
        questions: [
          { question: "8.1 Are employees aware of the importance of halal compliance?", answer: "Yes" },
          { question: "8.2 re there document standard operating procedures for Hala compliance?", answer: "No" },
          { question: "8.3 Are are regular internal audit conducted to ensure Halal compliance?", answer: "Yes" },
          { question: "8.4 Are employee aware of the importance of Halal compliance?", answer: "No" }
        ]
      },
      {
        section: "Miscellaneous",
        questions: [
          { question: "9.1 Are employees aware of the importance of halal compliance?", answer: "Yes" },
          { question: "9.2 re there document standard operating procedures for Hala compliance?", answer: "No" },
          { question: "9.3 Are are regular internal audit conducted to ensure Halal compliance?", answer: "Yes" },
          { question: "9.4 Are employee aware of the importance of Halal compliance?", answer: "No" }
        ]
      }
  ];

const PrimaryAuditReport = () => {
  return (
    <>
      <Box
        sx={{ padding: "20px", backgroundColor: "fffff", borderRadius: "8px" }}
      >
        {/* Header Section */}
        <Typography
          variant="h6"
          sx={{
            fontWeight: "500",
            marginBottom: "20px",
            bgcolor: "#F6F8FA",
            color: "#616161",
          }}
        >
          General Information
        </Typography>

        {/* Information Rows */}
        <Grid container spacing={3}>
          {/* Business Type */}
          <Grid item xs={12} md={12}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Typography
                variant="body1"
                sx={{ fontWeight: 500, color: "#313131" }}
              >
                1.1 Business type
              </Typography>
              <Typography variant="body1">Restaurant</Typography>
            </Box>
          </Grid>

          {/* Number of Employees */}
          <Grid item xs={12} md={12}>
            <Box>
              <Typography
                variant="body1"
                sx={{ fontWeight: 500, marginBottom: "10px" }}
              >
                1.2 Number of employees
              </Typography>
              <Box
                sx={{ display: "flex", justifyContent: "flex-start", gap: 2 }}
              >
                <Typography>Full time: 24</Typography>
                <Typography>Part time: 22</Typography>
              </Box>
            </Box>
          </Grid>

          {/* Operational Hours */}
          <Grid item xs={12} md={12}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                1.3 Operational hours
              </Typography>
              <Typography>8 hours</Typography>
            </Box>
          </Grid>

          {/* Halal Certification Body */}
          <Grid item xs={12} md={6}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                1.4 Halal certification body
              </Typography>
              <Typography>HSA</Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Box
        sx={{ padding: "20px", backgroundColor: "fffff", borderRadius: "8px" }}
      >
        {/* Header Section */}
        <Typography
          variant="h6"
          sx={{
            fontWeight: "500",
            marginBottom: "20px",
            bgcolor: "#F6F8FA",
            color: "#616161",
          }}
        >
         Raw Materials & ingredients
        </Typography>

        {/* Information Rows */}
        <Grid container spacing={3}>
          {/* Business Type */}
          <Grid item xs={12} md={12}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Typography
                variant="body1"
                sx={{ fontWeight: 500, color: "#313131" }}
              >
                2.1 Are all raw material and ingredient used halal certified
              </Typography>
              <Typography variant="body1">Restaurant</Typography>
            </Box>
          </Grid>

          {/* Number of Employees */}
          <Grid item xs={12} md={12}>
            <Box>
              <Typography
                variant="body1"
                sx={{ fontWeight: 500, marginBottom: "10px" }}
              >
                1.2 Number of employees
              </Typography>
              <Box
                sx={{ display: "flex", justifyContent: "flex-start", gap: 2 }}
              >
                <Typography>Full time: 24</Typography>
                <Typography>Part time: 22</Typography>
              </Box>
            </Box>
          </Grid>

          {/* Operational Hours */}
          <Grid item xs={12} md={12}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                1.3 Operational hours
              </Typography>
              <Typography>8 hours</Typography>
            </Box>
          </Grid>

          {/* Halal Certification Body */}
          <Grid item xs={12} md={6}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                1.4 Halal certification body
              </Typography>
              <Typography>HSA</Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Box sx={{p:2}}>
      {data.map((sectionData, index) => (
        <Box key={index} mb={4}>
          <Typography variant="h6" sx={{ fontWeight: 500,bgcolor:"#F6F8FA",pl:2,mb:4,}}>
            {sectionData.section}
          </Typography>
          <Grid container spacing={2}>
            {sectionData.questions.map((item, idx) => (
              <Grid item xs={12} key={idx}>
                <Card variant="outlined" style={{ padding: "12px" }}>
                  <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                   <Box>
                   <Typography style={{ fontSize: 16, fontWeight: 500 }}>
                      {item.question}
                    </Typography>
                    <Typography style={{ color: "black", fontWeight: 500, marginTop: 4 }}>
                      {item.answer}
                    </Typography>
                    {item.note && (
                      <Box mt={2} style={{ backgroundColor: "#f9f9f9", padding: "8px", borderRadius: "4px" }}>
                        <Typography variant="body2" style={{ fontStyle: "italic" }}>
                          {item.note}
                        </Typography>
                      </Box>
                    )}
                   </Box>
                    {item.image && (
                      <Avatar
                        src={item.image}
                        alt="Image"
                        variant="rounded"
                        style={{ width: 250, height: 120, marginTop: 8 }}
                      />
                    )}
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      ))}
    </Box>
    </>
  );
};

export default PrimaryAuditReport;
